<template>
  <div id="sign-up-modal">
    <div class="row">
      <div class="col-12">{{$t('signup.modal.title')}}</div>
    </div>
    <div class="row">
      <div class="col-12 subtitle">{{$t('signup.modal.subtitle')}}</div>
    </div>
    <div class="row">
      <div class="col-12 no-gutters">
        <base-input
          @baseInputValue="emailChanged($event)"
          :placeHolder="$t('singup.modal.email.placeholder')"
          class="email-input"
        />
      </div>
    </div>
    <div class="row">
      <base-button @click="signUp" :text="$t('signup.modal.buttonText')" class="col-12" />
    </div>
    <div class="row">
      <div class="col-12">
        <span class="cancel" @click="cancel">{{$t('signup.modal.cancelText')}}</span>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions } from 'vuex';
import BaseInput from '@/components/shared/elements/BaseInput';
import BaseButton from '@/components/shared/elements/BaseButton';

export default {
  name: 'SignUpModal',
  components: {
    BaseInput,
    BaseButton,
  },
  props: {},
  data() {
    return {
      email: undefined,
    };
  },
  created() {},
  methods: {
    ...mapActions({
      signUpForBeta: 'users/signUpForBeta',
    }),
    async signUp() {
      if (!this.isEmailValid()) {
        this.$swal(
          this.$t('signup.error.title'),
          this.$t('signup.error.message'),
          'error',
        );
        return;
      }
      const result = await this.signUpForBeta(this.email);
      if (result.error) {
        this.$swal(
          this.$t('signup.error.title'),
          this.$t(result.error),
          'error',
        );
      } else {
        this.$swal(
          this.$t('signup.success.title'),
          this.$t('signup.success.message'),
          'success',
        );
      }

      this.$eventBus.closeModal();
    },
    cancel() {
      this.$eventBus.closeModal();
    },
    emailChanged(email) {
      this.email = email;
    },
    isEmailValid() {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.email).toLowerCase());
    },
  },
};
</script>

<style lang="scss" scoped>
#sign-up-modal {
  min-width: 500px;
  padding: 20px;
  .row {
    margin: 10px 0;
  }
  .email-input {
    margin: 10px 0;
  }
  .cancel {
    cursor: pointer;
    &:hover {
      color: $secondary-color;
    }
  }
  .subtitle {
    opacity: 0.75;
  }
}
</style>

